import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ShieldCheck, Lock, Eye, CheckCircle, Zap } from 'lucide-react';
export function Footer() {
  const [accessibilityEnabled, setAccessibilityEnabled] = useState(true);
  return <footer className="bg-slate-900 text-white pt-20 pb-10 border-t-8 border-federal-blue" data-id="element-168">
      <div className="max-w-7xl mx-auto px-4 md:px-8" data-id="element-169">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-60px'
      }} transition={{
        duration: 0.6,
        ease: [0.22, 1, 0.36, 1]
      }} className="grid md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16" data-id="element-170">
          <div className="lg:col-span-1" data-id="element-171">
            <div className="flex items-center gap-2 mb-6" data-id="element-172">
              <div className="w-10 h-8 flex items-center justify-center overflow-hidden" data-id="element-173">
                <img src="https://cdn.magicpatterns.com/uploads/cMrkjmuEGCTQik26MvLHNF/ChatGPT_Image_Apr_14,_2026,_01_45_07_PM.png" alt="Codes & Cogs Logo" className="h-full w-auto object-contain brightness-0 invert" data-id="element-174" />
              </div>
              <div className="flex flex-col leading-tight" data-id="element-175">
                <span className="text-white font-black text-lg tracking-tighter uppercase" data-id="element-176">
                  Codes & Cogs
                </span>
                <span className="text-muted-gold text-[8px] font-bold tracking-[0.2em] uppercase" data-id="element-177">
                  Federal Solutions
                </span>
              </div>
            </div>
            <p className="text-slate-400 text-sm leading-relaxed mb-8" data-id="element-178">
              A certified WOSB/EDWOSB entity dedicated to securing the federal
              mission through digital excellence and physical infrastructure.
            </p>
            <div className="flex items-center gap-3 p-3 bg-white/5 border border-white/10 rounded" data-id="element-179">
              <CheckCircle className="w-5 h-5 text-green-500" data-id="element-180" />
              <div data-id="element-181">
                <p className="text-[10px] font-bold uppercase tracking-widest text-slate-300" data-id="element-182">
                  SAM.gov Status
                </p>
                <p className="text-xs font-bold text-white" data-id="element-183">
                  Active Registration
                </p>
              </div>
            </div>
          </div>
          <div data-id="element-184">
            <h4 className="font-bold text-sm uppercase tracking-widest mb-6 text-muted-gold" data-id="element-185">
              Products & Capabilities
            </h4>
            <ul className="space-y-3 text-sm text-slate-400" data-id="element-186">
              <li data-id="element-187">
                <Link to="/comply-plus" className="text-white font-bold hover:text-muted-gold transition-colors flex items-center gap-2" data-id="element-188">
                  Comply+ Platform <Zap className="w-3 h-3 text-muted-gold" data-id="element-189" />
                </Link>
              </li>
              <li data-id="element-190">
                <a href="#" className="hover:text-white transition-colors" data-id="element-191">
                  Software Development
                </a>
              </li>
              <li data-id="element-192">
                <a href="#" className="hover:text-white transition-colors" data-id="element-193">
                  Web & Accessibility
                </a>
              </li>
              <li data-id="element-194">
                <a href="#" className="hover:text-white transition-colors" data-id="element-195">
                  Physical Security
                </a>
              </li>
              <li data-id="element-196">
                <a href="#" className="hover:text-white transition-colors" data-id="element-197">
                  IT Supply Chain
                </a>
              </li>
              <li data-id="element-198">
                <a href="#" className="hover:text-white transition-colors" data-id="element-199">
                  Healthcare IT
                </a>
              </li>
            </ul>
          </div>
          <div data-id="element-200">
            <h4 className="font-bold text-sm uppercase tracking-widest mb-6 text-muted-gold" data-id="element-201">
              Compliance
            </h4>
            <ul className="space-y-3 text-sm text-slate-400" data-id="element-202">
              <li data-id="element-203">
                <a href="#" className="hover:text-white transition-colors" data-id="element-204">
                  NIST 800-171
                </a>
              </li>
              <li data-id="element-205">
                <a href="#" className="hover:text-white transition-colors" data-id="element-206">
                  NIST 800-53
                </a>
              </li>
              <li data-id="element-207">
                <a href="#" className="hover:text-white transition-colors" data-id="element-208">
                  Section 508
                </a>
              </li>
              <li data-id="element-209">
                <a href="#" className="hover:text-white transition-colors" data-id="element-210">
                  HIPAA Compliance
                </a>
              </li>
              <li data-id="element-211">
                <a href="#" className="hover:text-white transition-colors" data-id="element-212">
                  TAA Compliance
                </a>
              </li>
              <li data-id="element-213">
                <a href="#" className="hover:text-white transition-colors" data-id="element-214">
                  USWDS
                </a>
              </li>
            </ul>
          </div>
          <div data-id="element-215">
            <h4 className="font-bold text-sm uppercase tracking-widest mb-6 text-muted-gold" data-id="element-216">
              Accessibility
            </h4>
            <div className="bg-white/5 p-4 rounded border border-white/10" data-id="element-217">
              <div className="flex items-center justify-between mb-4" data-id="element-218">
                <div className="flex items-center gap-2" data-id="element-219">
                  <Eye className="w-4 h-4 text-slate-300" data-id="element-220" />
                  <span className="text-xs font-bold uppercase tracking-wider" data-id="element-221">
                    Section 508
                  </span>
                </div>
                <button onClick={() => setAccessibilityEnabled(!accessibilityEnabled)} className={`w-10 h-5 rounded-full relative transition-colors ${accessibilityEnabled ? 'bg-muted-gold' : 'bg-slate-700'}`} data-id="element-222">
                  <div className={`absolute top-1 w-3 h-3 bg-white rounded-full transition-all ${accessibilityEnabled ? 'left-6' : 'left-1'}`} data-id="element-223" />
                </button>
              </div>
              <p className="text-[10px] text-slate-400 leading-normal" data-id="element-224">
                This portal is designed to meet or exceed Section 508 standards.
                Toggle high-contrast and screen-reader optimizations.
              </p>
            </div>
          </div>
        </motion.div>
        <div className="pt-10 border-t border-white/10 flex flex-col md:flex-row justify-between items-center gap-6" data-id="element-225">
          <div className="flex items-center gap-6 text-[10px] font-bold uppercase tracking-widest text-slate-500" data-id="element-226">
            <span data-id="element-227">© 2026 Codes & Cogs LLC</span>
            <Link to="/privacy-policy" className="hover:text-white transition-colors" data-id="element-228">
              Privacy Policy
            </Link>
            <Link to="/security-disclaimer" className="hover:text-white transition-colors" data-id="element-229">
              Security Disclaimer
            </Link>
          </div>
          <div className="flex items-center gap-4" data-id="element-230">
            <div className="flex items-center gap-2 px-3 py-1.5 bg-white/5 border border-white/10 rounded text-[10px] font-bold text-slate-300" data-id="element-231">
              <Lock className="w-3 h-3 text-muted-gold" data-id="element-232" />
              SECURE PORTAL
            </div>
            <div className="flex items-center gap-2 px-3 py-1.5 bg-white/5 border border-white/10 rounded text-[10px] font-bold text-slate-300" data-id="element-233">
              <ShieldCheck className="w-3 h-3 text-muted-gold" data-id="element-234" />
              SAM REGISTERED
            </div>
          </div>
        </div>
      </div>
    </footer>;
}